export const ResellerFlowNotificationDataHooks = {
  container: 'reseller-flow-notification-container',
  description: 'reseller-flow-notification-description',
};
